import FieldConfig from "../../../proto/field-config"
import {GROUP_NUMBER} from "../../../../gd/const/fields/field2-groups"
import FieldTimeSpent from "../../../generic/datetime/time-spent/time-spent"
import {FieldFilterType} from "../../../proto/types"

export default class FieldBreakDuration extends FieldTimeSpent {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                  = "Break duration"
        this.typeGroup                  = GROUP_NUMBER
        this.typeDescription            = "Break duration"
        this.filterType                 = FieldFilterType.NUMBER

        this.placeholderValueExample    = "Enter break duration e.g. 7h 30m"
        this.hasStartEnd                = false

        this.presetMinutes = [
            {value:30, label: "30"},
            {value:45, label: "45"}
        ]

        this.presetHours = [
            {value: 60,  label:  "1"},
            {value: 120,  label:  "2"},
            {value: 180,  label:  "3"},
        ]

    }

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)
        return this.getDisplayValue(rawValue)
    }
}
